import { useHandler } from "@redotech/react-util/hook";
import { RedoBaseModal } from "@redotech/redo-web/arbiter-components/modal/redo-base-modal";
import {
  RedoModalFooter,
  RedoModalHeader,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { useNavigate } from "react-router-dom";

export interface MarketingModalProps {
  image: string;
  title: string;
  subtitle: string;
  onDismiss: () => void;
  isOpen: boolean;
  action:
    | { type: "external"; href: string; text: string }
    | { type: "internal"; route: string; text: string }
    | { type: "action"; onClick: () => void; text: string };
}

export const MarketingModal = memo(function MarketingModal({
  isOpen,
  onDismiss,
  image,
  title,
  subtitle,
  action,
}: MarketingModalProps) {
  const navigate = useNavigate();

  const handlePrimary = useHandler(() => {
    switch (action.type) {
      case "external": {
        window.open(action.href, "_blank");

        break;
      }
      case "internal": {
        navigate(action.route);

        break;
      }
      case "action": {
        action.onClick();
        break;
      }
      // No default
    }
  });

  return (
    <RedoBaseModal darkMode isOpen={isOpen} onModalCloseRequested={onDismiss}>
      <Flex pl="3xl" pr="3xl" pt="3xl">
        <Flex overflow="hidden" radius="sm">
          <img src={image} />
        </Flex>
      </Flex>
      <RedoModalHeader
        cancelClicked={onDismiss}
        hideCloseButton
        subtitle={subtitle}
        title={title}
      />
      <RedoModalFooter
        primaryButton={{
          text: action.text,
          theme: "action",
          onClick: handlePrimary,
        }}
        secondaryButton={{ text: "Dismiss", onClick: onDismiss }}
      />
    </RedoBaseModal>
  );
});
